import { render } from "./CollectList.vue?vue&type=template&id=7fc82613"
import script from "./CollectList.vue?vue&type=script&lang=js"
export * from "./CollectList.vue?vue&type=script&lang=js"

import "./CollectList.vue?vue&type=style&index=0&id=7fc82613&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__